<template>
  <div class="key-container">
    <div class="key-header">
      <div class="title">我的应用</div>
      <el-button @click="paramShow.addAppVisible = true"
                 class="yello-btn">创建新应用</el-button>
    </div>
    <div class="key-body">
      <el-collapse v-model="activeName"
                   accordion
                   style="border:none">
        <el-collapse-item v-for="item in userAppKeyList"
                          :key="item.appId"
                          :name="item.name">
          <template slot="title">
            <el-row style="width:100%">
              <el-col :span="18">
                <div style="display: inline-flex; height: 35px; line-height: 35px; font-size: 16px; align-items: center;">
                  <i class="el-icon-menu"
                     style="margin: 0px 24px 0px 8px; font-size: 18px; color:#ffd100"></i>
                  <span style="margin-right: 16px; font-weight:600;color:#000">{{item.name}}</span>
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.65);">{{item.createTime+' 创建'}}</span>
                </div>
              </el-col>
              <el-col :span="6"
                      style="height:48px">
                <div class="operate-panel"
                     style="float:right">
                  <el-button type="text"
                             @click.stop="editAppName(item)"
                             icon="el-icon-edit">编辑</el-button>
                  <el-button type="text"
                             @click.stop="addAppKey(item)"
                             icon="el-icon-circle-plus-outline">添加</el-button>
                  <!-- <el-button type="text"
                             @click.stop="deleteApp(item)"
                             icon="el-icon-delete">删除</el-button> -->
                </div>
              </el-col>
            </el-row>
          </template>
          <el-table :data="item.keys"
                    :height="getHeiht(item.keys)">
            <el-table-column prop="keyName"
                             label="Key 名称">
            </el-table-column>
            <el-table-column prop="key"
                             label="Key">
            </el-table-column>
            <el-table-column prop="platformName"
                             label="绑定服务">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="editkey(scope.row)"
                           type="text"
                           size="small">设置</el-button>
                <router-link :to="{
                      path: '/console/flowmanage/',
                      query: {
                          key: scope.row.key,
                          platform:scope.row.platformName
                      }
                  }">
                  <el-button style="margin-left:10px"
                             type="text"
                             size="small">查看配额</el-button>
                </router-link>
                <!-- <el-button type="text"
                           size="small">删除</el-button> -->
                <el-button style="margin-left:10px"
                           type="text"
                           size="small"
                           @click="movekey(scope.row)">移动</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- 添加应用名称对话框 -->
    <add-app-dialog :paramShow="paramShow"
                    v-if="paramShow.addAppVisible"
                    @updateList="getUserAppKeyList"></add-app-dialog>

    <!-- 修改应用名称对话框  -->
    <edit-app-dialog :paramShow="paramShow"
                     :editItem="editItem"
                     v-if="paramShow.editAppVisible"
                     @updateList="getUserAppKeyList"></edit-app-dialog>

    <!-- 添加应用Key对话框  -->
    <add-key-dialog :paramShow="paramShow"
                    :addAppKeyItem="addAppKeyItem"
                    v-if="paramShow.addKeyVisible"
                    @updateActive="updateActive"
                    @updateList="getUserAppKeyList"></add-key-dialog>

    <!-- 设置Key对话框  -->
    <edit-key-dialog :paramShow="paramShow"
                     :editKeyItem="editKeyItem"
                     v-if="paramShow.editKeyVisible"
                     @updateList="getUserAppKeyList"></edit-key-dialog>
    <!-- 移动Key对话框  -->
    <move-key-dialog :paramShow="paramShow"
                     :moveKeyItem="moveKeyItem"
                     :userAppList="userAppList"
                     v-if="paramShow.moveKeyVisible"
                     @updateList="getUserAppKeyList"></move-key-dialog>

  </div>
</template>

<script>
import http from '@/http/index.js'

import AddAppDialog from './AddAppDialog.vue';
import AddKeyDialog from './AddKeyDialog.vue';
import EditKeyDialog from './EditKeyDialog.vue';
import EditAppDialog from './EditAppDialog.vue';
import MoveKeyDialog from './MoveKeyDialog.vue';

export default {
  components: {
    AddAppDialog,
    AddKeyDialog,
    EditKeyDialog,
    EditAppDialog,
    MoveKeyDialog
  },
  data() {
    return {
      activeName: null,
      userAppKeyList: null,
      userAppList: null,
      paramShow: {
        editAppVisible: false,
        addAppVisible: false,
        addKeyVisible: false,
        editKeyVisible: false,
        moveKeyVisible: false
      },
      editItem: null,
      addAppKeyItem: null,
      editKeyItem: null,
      moveKeyItem: null
    };
  },
  async created() {
    await this.getUserAppKeyList();
    if (this.userAppKeyList && this.userAppKeyList.length >= 1) {
      this.activeName = this.userAppKeyList[0].name
    }
  },
  methods: {
    async getUserAppKeyList() {
      const res = await http.user.getAppKeyList();
      this.userAppKeyList = res;
    },
    getHeiht(keys) {
      if (keys && keys.length) {
        return 58 * (keys.length) + 49
      }
    },
    updateActive(activeName) {
      this.activeName = activeName
    },
    editAppName(appItem) {
      this.editItem = appItem;
      this.paramShow.editAppVisible = true;
    },
    addAppKey(appItem) {
      this.addAppKeyItem = appItem;
      this.paramShow.addKeyVisible = true;
    },
    async editkey(keyItem) {
      const res = await http.key.getInfo(keyItem.id);
      this.editKeyItem = res;
      this.paramShow.editKeyVisible = true;
    },
    async movekey(keyItem) {
      const res = await http.app.getAppList();
      this.userAppList = res;
      this.moveKeyItem = keyItem;
      this.paramShow.moveKeyVisible = true;
    },
    // 删除应用
    async deleteApp(appItem) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该应用, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err);
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除');
      }
      this.$message.success('删除用户成功！');
    }
  }
};
</script>

<style lang="less" scoped>
.key-header {
  display: flex;
  padding: 5px;
  justify-content: space-between;
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
    font-weight: 500;
    line-height: 32px;
  }
  .yello-btn {
    background: #ffd100;
    // border-radius: 40px;
    color: rgba(0, 0, 0, 0.84);
    padding: 0 15px;
    line-height: 32px;
    border: none;
    cursor: pointer;
  }
}
.operate-panel {
  height: 100%;
  display: flex;
  align-items: center;
  .el-button {
    margin-right: 10px;
  }
}
.el-collapse-item {
  margin-bottom: 8px;
  border: none;
  height: 100%;
  background: rgb(255, 255, 255);
  padding: 0px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
}
/deep/.el-collapse-item__content{
  padding-bottom: 0px!important;
}
.el-table /deep/ thead {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500px;
  height: 50px;
}
/deep/ table {
  border-spacing: 0px 1px !important;
}

/deep/.el-table__body-wrapper{
  overflow-y: hidden !important;
}
</style>
